import { Helmet } from 'react-helmet-async';
import { useState, useEffect } from 'react';
import { useSelector } from "react-redux";
import { Navigate, useNavigate } from 'react-router-dom';
import axios from "axios";
import "./styles.css";

// @mui
import {
  Card,
  Avatar,
  Button,
  Container,
  Typography,
  TablePagination,
  Dialog,
  Box,
  Stack
} from '@mui/material';

// components
import Scrollbar from '../components/scrollbar';
import LightingModePreview from '../pages/LightingModeCRUDPages/LightingModePreview';

// ----------------------------------------------------------------------

export default function HuntersReportAll() {

  const [members, setMembers] = useState([]);
  const [dataloaded, setDataLoaded] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);

  const [openModal, setOpenModal] = useState(false);
  const [selectedMode, setSelectedMode] = useState(null);

  const { user: currentUser } = useSelector((state) => state.auth);

  const navigate = useNavigate();
  const SERVER_URL = process.env.REACT_APP_BACKEND_SERVER_URL;

  useEffect(() => {
    if (!dataloaded) {
      getAllHunters();
    }
  }, [dataloaded]);

  const getAllHunters = async () => {
    try {
      const response = await axios.get(SERVER_URL + "/api/lightingmodes");
      setMembers(response.data);
      setDataLoaded(true);
    } catch (err) {
      console.log("error");
    }
  };

  if (!currentUser) return <Navigate to="/login" />;

  return (
    <>
      <Helmet>
        <title> Pametna rasvjeta </title>
      </Helmet>

      <Container
        maxWidth={false}
        sx={{
          backgroundColor: '#001536',
          height: '100%',
          padding: '20px',
        }}
      >

        <Typography
          variant="h6"
          sx={{
            p: 2,
            pl: 1,
            color: '#ff9800',
            fontWeight: 600,
          }}
        >
          Pregled modova
        </Typography>

        <Card sx={{ backgroundColor: '#00122E' }}>
          <Stack spacing={2} p={2}>

            {members
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => {

                const { id, name, description } = row;

                return (
                  <Card
                    key={id}
                    sx={{
                      p: 2,
                      backgroundColor: '#00122E',
                      color: '#ff9800',
                      borderRadius: '20px',
                      position: 'relative',

                      // stabilni border
                      '&::before': {
                        content: '""',
                        position: 'absolute',
                        inset: 0,
                        borderRadius: '20px',
                        padding: '1px',
                        background: 'rgba(255,255,255,0.2)',
                        WebkitMask:
                          'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                        WebkitMaskComposite: 'xor',
                        maskComposite: 'exclude',
                        pointerEvents: 'none',
                      }
                    }}
                  >

                    {/* HEADER */}
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                      <Avatar sx={{ mr: 2 }}>
                        {name?.[0]}
                      </Avatar>

                      <Typography sx={{ fontWeight: 600, fontSize: '16px' }}>
                        {name}
                      </Typography>
                    </Box>

                    {/* DESCRIPTION */}
                    <Typography sx={{ mb: 2, color: '#ffb74d' }}>
                      {description}
                    </Typography>

                    {/* ACTIONS */}
                    <Box
                      sx={{
                        display: 'flex',
                        gap: 1,
                        justifyContent: 'flex-end' // 🔥 poravnato desno
                      }}
                    >
                      <Button
                        onClick={() => {
                          setSelectedMode(row);
                          setOpenModal(true);
                        }}
                        sx={{
                          minWidth: 100,
                          backgroundColor: '#001B44',
                          color: '#ff9800',                // 🔥 tekst orange
                          border: '1px solid #ff9800',     // 🔥 border orange
                          '&:hover': {
                            backgroundColor: '#001B44',
                            border: '1px solid #ffa726',   // 🔥 malo svjetliji hover
                            color: '#ffa726'
                          }
                        }}
                      >
                        Pregled
                      </Button>

                      <Button
                        onClick={() =>
                          navigate("/lightingmode/update", { state: row })
                        }
                        sx={{
                          minWidth: 100,
                          backgroundColor: '#001B44',
                          color: '#ff9800',                // 🔥 tekst orange
                          border: '1px solid #ff9800',     // 🔥 border orange
                          '&:hover': {
                            backgroundColor: '#001B44',
                            border: '1px solid #ffa726',   // 🔥 malo svjetliji hover
                            color: '#ffa726'
                          }
                        }}
                      >
                        Uredi
                      </Button>
                    </Box>

                  </Card>
                );
              })}

          </Stack>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={members.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={(e, newPage) => setPage(newPage)}
            onRowsPerPageChange={(e) =>
              setRowsPerPage(parseInt(e.target.value, 10))
            }
            sx={{
              color: '#ff9800',

              '& .MuiTablePagination-selectLabel': {
                color: '#ff9800',
              },
              '& .MuiTablePagination-displayedRows': {
                color: '#ff9800',
              },
              '& .MuiSelect-icon': {
                color: '#ff9800',
              },
              '& .MuiInputBase-root': {
                color: '#ff9800',
              },
              '& .MuiIconButton-root': {
                color: '#ff9800',
              },
              '& .MuiIconButton-root.Mui-disabled': {
                color: 'rgba(255,255,255,0.3)',
              },
              '& .MuiTablePagination-selectLabel': {
                color: '#ff9800',
                marginTop: '12px'   // 👈 OVO PORAVNA
              },
              '& .MuiTablePagination-displayedRows': {
                color: '#ff9800',
                marginTop: '14px'
              },
            }}
          />

        </Card>

        {/* MODAL */}
        <Dialog
          open={openModal}
          onClose={() => setOpenModal(false)}
          maxWidth="lg"
          fullWidth
          PaperProps={{
            sx: {
              backgroundColor: 'transparent',
              boxShadow: 'none'
            }
          }}
        >
          {selectedMode && (
            <LightingModePreview
              data={selectedMode}
              onClose={() => setOpenModal(false)}
            />
          )}
        </Dialog>

      </Container>
    </>
  );
}